import React from 'react';
import { ListSubheader, Paper } from '@mui/material';
import { usePDIGraphDetails } from '../../data/DataProviders/PDIGraphDataProvider';
import { isDataLoaded, DataState } from '../../types';
import { DataIndicators } from '../DataIndicators';
import { Icon } from '../../lib/icons';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
import { ReusableTrendsGraph } from '../ReusableTrendsGraph';
import { INStrendData } from '../../types/device';
export const PDIGraph: React.FC<{
    monthValue: number;
    pdiViewFullTrend?: boolean;
    popUpEvent?: any;
    alarmNotifyContent?: any;
}> = (props) => {
   
    const [pdiTrend, setTrendData] = React.useState<INStrendData>({ state: DataState.Loading });

    const classes = chartLabelNameStyle();
    const pdiResponseData = usePDIGraphDetails();   
    const isEmpty = isDataLoaded(pdiResponseData) ? pdiResponseData.value.channelsData.length === 0 : false;
    const tickInterval = props.monthValue === 0 ? 336 * 3600 * 1000 : 744 * 3600 * 1000;
    const pdiGraphlabelName =
        props.monthValue === 0 ? '3 month daily maximum PDI (mW)' : '12 month daily maximum PDI (mW)';
    const pdiData: any = [];

    React.useEffect(() => {

        if (isDataLoaded(pdiResponseData)) {    
            const deviceId = isDataLoaded(pdiResponseData) ? pdiResponseData.value.deviceId : '';
            const deviceName = isDataLoaded(pdiResponseData) ? pdiResponseData.value.deviceName : '';
            pdiResponseData.value.channelsData.map((item) => {
                const maxPdiObj = {
                    id: item.channelNumber,
                    deviceId: deviceId,
                    deviceName: deviceName,
                    channelName: item.channelName,
                    value: item.pdiChartData.map((val) => ({                      
                        dateTime: new Date(val.dateTime).toISOString(),
                        value: val.maxPdi,  
                        isNewAlarm: val.isNewAlarm,
                        alarmCount: val.alarmCount                   
                    })),
                    unit: '',
                };

                const maxAlarmObj = {
                    id: item.channelNumber,
                    deviceId: deviceId,
                    deviceName: deviceName,
                    channelName: `${item.channelName} - Alarm Point`,
                    value: item.pdiChartData.map((val) => ({
                        dateTime: new Date(val.dateTime).toISOString(),
                        value: val.alarmPoint,
                    })),
                    unit: '',
                };
                pdiData.push(maxPdiObj);
                pdiData.push(maxAlarmObj);

            });
           
            setTrendData({
                state: DataState.Loaded,
                value: pdiData,
            });
           }
    }, [pdiResponseData]);

    const openPDIQmaxDialogBox = (): void => {
        props.popUpEvent(true);
    };
    /* eslint-disable */
    const downloadCSV = (): void => { };

    return (
        <div data-testid="device-info-PDI">
            <Paper style={{ border: '0px' }}>
                <DataIndicators
                    errorMessage="Record not found"
                    emptyMessage="Record not found"
                    data={pdiResponseData}
                    emptyIcon="BarChart"
                    isEmpty={isEmpty}
                    isDetailedInfo={false}
                />
            </Paper>
            {isDataLoaded(pdiResponseData) && (
                <>
                    {pdiResponseData.value.channelsData.length > 0 && (
                        <Paper>
                            <div className={classes.titleBoxContent}>
                                <ListSubheader color="primary" component="div" style={{ fontWeight: 600 }}>
                                    {pdiGraphlabelName}                                 
                                    <span className={classes.icon}>
                                        {<Icon.Info className={classes.infoicon} onClick={openPDIQmaxDialogBox} />}
                                    </span>
                                </ListSubheader>
                                {props.alarmNotifyContent}
                            </div>

                            <ReusableTrendsGraph
                                large
                                trendsData = {pdiTrend}
                                downloadCSV = {downloadCSV}
                                Inactive = {true}
                                tickInterval = {tickInterval}
                               
                            />                           
                        </Paper>
                    )}
                </>
            )}
        </div>
    );
};
